import { trpc } from "@/lib/trpc";

export const useChatProvidersQuery = (enabled: boolean = true) => {
    return trpc.chatProviders.findAll.useQuery(undefined, { enabled });
};

export const useChatProviderByIdQuery = (id: string, enabled: boolean = true) => {
    return trpc.chatProviders.findById.useQuery({ id }, { enabled: !!id && enabled });
};

export const useChatProviderQuery = (provider: string, enabled: boolean = true) => {
    return trpc.chatProviders.findByProvider.useQuery({ provider }, { enabled: !!provider && enabled });
};

export const useEnabledChatProviderQuery = (enabled: boolean = true) => {
    return trpc.chatProviders.findEnabled.useQuery(undefined, { enabled });
};
